<div class="min-h-screen flex flex-col items-center justify-center p-6" style="background: linear-gradient(135deg, #003085 0%, #0075FF 100%);">
      <div class="bg-blue-50/90 rounded-2xl p-8 w-full max-w-md backdrop-blur-sm border border-blue-100">
        <div class="flex justify-center mb-6">
          <!-- Icono de error con tono azul -->
          <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        
        <h1 class="text-2xl font-bold text-blue-900 text-center mb-4">Error al validar tus datos</h1>
        
        <p class="text-blue-800 text-center">
          Ha ocurrido un problema al validar tus datos. Por favor, comunícate con tu asesor o acércate a una oficina para resolver este inconveniente.
        </p>
      </div>
    </div>